module.exports = __webpack_public_path__ + "assets/fa-brands-400.ec3cfddedb8bebd2d7a3fdf511f7c1cc.woff";